import React from 'react';
import { Link } from "react-router-dom";
import Axios from "axios";
import { useState, useEffect } from 'react';
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import { useForm ,Controller} from "react-hook-form";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { RegisterAPIURL } from '../apiconstants/constants';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import LoadingSpinner from '../helpers/loadingspinner';
import Swal from 'sweetalert2';
import ConsultantLayout from '../commonlayouts/consultantlayout';
import Select from 'react-select';
import { useCountry } from '../contexts/countrycodecontext.js';

function AddUser() {

  const formSchema = Yup.object().shape({
    terms: Yup.bool() // use bool instead of boolean
      .oneOf([true], "You must accept the terms and conditions"),
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    mobile: Yup.string().required("Mobile Number is required"),
    roleID:Yup.string().required("User Type is required"),
    email: Yup.string().email().required("Email is required"),
    password: Yup.string()
      .required('Password is mandatory')
      .matches(
        /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,15}$/,
        'one Capital,one Small Letter, and one number, characters should be between 6 to 15',
      ),

    confirmPwd: Yup.string()
      .required('Password is mandatory')
      .oneOf([Yup.ref('password')], 'Passwords does not match'),
  })
      const {  selectedCountry } = useCountry();
  console.log("46",selectedCountry)
  const formOptions = { resolver: yupResolver(formSchema) }
  const { register, handleSubmit, reset, formState,control, } = useForm(formOptions);
  const { errors } = formState
  const { isSubmitting } = formState;
  const apiUrl = RegisterAPIURL.APIURL;

  const [loginType,setloginType] = useState([
    {LoginID:"3",loginName:"User"},
    // {LoginID:"4",loginName:"Cem"},
    ])
//   const [roleid, setRoleID] = React.useState(2);
  const [isLoading, setIsLoading] = useState(false);

  const employeeGuid=localStorage.getItem("guid")
  const clientData = JSON.parse(localStorage.getItem("clientData"));

   const onSubmit = (data, e) => {
    e.preventDefault();
    e.target.reset();
    setIsLoading(true);
    const formData = new FormData();
    formData.append('firstName', data.firstName);
    formData.append('lastName', data.lastName);
    formData.append('email', data.email);
    formData.append('mobileNumber', data.mobile);
    formData.append('password', data.password);
    formData.append('employeeGuid', employeeGuid );
    formData.append('LogoURL', clientData?.logoURL);
    formData.append('roleID', data.roleID);
    formData.append('CompanyName', clientData?.companyName);
    formData.append('Logolink', null);
    formData.append('CountryMappings', data.CountryMappings.map(c => c.value));
     console.log("selectedCountry",selectedCountry)
    formData.append('Usertype', data.Usertype);

    Axios.post(apiUrl, formData)
      .then((result) => {


        setIsLoading(false);
        if (result.data.message === "Success") {
          
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Registration successful, please check your email for verification instructions.',
            showConfirmButton: false,
            timer: 5000
          })
          reset(); 
          
          //toast.success('Data Saving', {autoClose:5000})

        }
        else if(result.data.message ==="already registered") {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Email Already Registered. If you dont know your password please visit the Forgot Password page.',
            showConfirmButton: false,
            timer: 5000
          })
          // toast.error('Issue with data format', {autoClose:5000})
        }
        else {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Something gone Wrong',
            showConfirmButton: false,
            timer: 5000
          })
        }

     }).catch(
        function (error) {
          console.log("Error" + error)
        })

    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, 5000);
    });

  }
  
  return (
    <>
  <ConsultantLayout>
       {isLoading ? (
    <center>
   <LoadingSpinner/>
    </center>
  )  :
  <div className="container-fluid mt-4 pb-5">
  <div style={{ display: 'flex', alignItems: 'center' }}>
<Link to="/Employer/ListOfUsers">
<i className="fa  fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px' }} aria-hidden="true"></i>
</Link>
<h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: '0' }}>User Registration</h2>
</div>

<hr/>
<div className="bg-gray mt-4">
    

     <form onSubmit={handleSubmit(onSubmit)} id="loginform">
    <div class="row" >
        
        
        <div class="" style={{height: 900}}>
               
                
                <div class="mb-3 mt-5">
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> First Name</Tooltip>)}>

<input
  placeholder='First Name'
  type="text"
  name="firstName"
  {...register("firstName")}
  className={`form-control shadow-sm ${errors.firstName ? 'is-invalid' : ''}`}

/>
</OverlayTrigger>
<div className="invalid-feedback"> {errors.firstName?.message}</div> 
                  </div>
                  <div class="mb-3 mt-4">
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Last Name</Tooltip>)}>
                  <input
                    placeholder='Last Name'
                    type="text"
                    name="lastName"
                    {...register("lastName")}
                    className={`form-control shadow-sm ${errors.lastName ? 'is-invalid' : ''}`}

                  />
                </OverlayTrigger>
                <div className="invalid-feedback"> {errors.lastName?.message}</div>  
                  </div>
                  <div class="mb-3 mt-4">
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Email</Tooltip>)}>
                  <input
                    placeholder='Email'
                    type="email"
                    name="email"
                    {...register("email")}
                    className={`form-control shadow-sm ${errors.email ? 'is-invalid' : ''}`}

                  />
                </OverlayTrigger>
                <div className="invalid-feedback"> {errors.email?.message}</div>
                    </div>

                    <div class="mb-3 mt-4">
                    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Mobile Number</Tooltip>)}>
                  <input
                    placeholder='Mobile Number'
                    type="text"
                    name="mobile"
                    {...register("mobile")}
                    className={`form-control shadow-sm ${errors.mobile ? 'is-invalid' : ''}`}

                  />
                </OverlayTrigger>
                <div className="invalid-feedback"> {errors.mobile?.message}</div>
                    </div>

                    <div class="mb-3 mt-4">
                    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Password</Tooltip>)}>
                  <input
                    placeholder='Password'
                    type="password"
                    name="password"
                    {...register("password")}
                    className={`form-control shadow-sm ${errors.password ? 'is-invalid' : ''}`}

                  />
                </OverlayTrigger>

                <div className="invalid-feedback">{errors.password?.message}</div>
                    </div>

                    <div class="mb-3 mt-4">
                    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>  Confirm Password</Tooltip>)}>
                  <input
                    name="confirmPwd"
                    type="password"
                    placeholder="Enter your Confirm password"
                    {...register('confirmPwd')}
                    className={`form-control shadow-sm${errors.confirmPwd ? 'is-invalid' : ''}`}
                  />
                </OverlayTrigger>
                <div className="invalid-feedback">{errors.confirmPwd?.message}</div>
                    </div>
                    <div class="mb-3 mt-4">
                    <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Role</Tooltip>)}>    

<select  {...register("roleID", { required: "Role Required" })} className={`form-control basic-form mt-3 ${errors.roleID ? 'is-invalid' : ''}`} style={{height:50,borderRadius:15,fontSize:12}}  >
<option value="">Select Role </option>
{
loginType.map((item,index)=>
{
return(

<option key={index}  value={item.LoginID}>{item.loginName}</option>

);
}

)
}
</select>
</OverlayTrigger>
<div className="mt-3">
  <Controller
    name="CountryMappings"
    control={control}
    rules={{ required: "At least one country must be selected" }}
    render={({ field }) => (
      <Select 
        {...field}
        options={[
          { value: "1", label: "India" },
          { value: "2", label: "United States" }
        ]}
        isMulti
        placeholder="Select Country"
        styles={{
          control: (provided) => ({
            ...provided,
            minHeight: 50,
            borderRadius: 15,
            borderColor: errors.CountryMappings ? 'red' : provided.borderColor,
          }),
          placeholder: (provided) => ({
            ...provided,
            fontSize: '12px', // 👈 Smaller font size
            color: '#999',     // Optional: lighter color for placeholder
          }),
          menu: (provided) => ({
            ...provided,
            fontSize: '12px',
          }),
          option: (provided) => ({
            ...provided,
            fontSize: '12px',
          }),}}
        className={` basic-form ${errors.CountryMappings ? 'is-invalid' : ''}`}
        onChange={(selectedOptions) => {
          field.onChange(selectedOptions);
        }}
      />
    )}
  />
  {errors.CountryMappings && (
    <div className="invalid-feedback d-block">{errors.CountryMappings.message}</div>
  )}
</div>
<div className="mt-3">
  <Controller
    name="Usertype"
    control={control}
    rules={{ required: "Designation type required" }}
    render={({ field }) => (
      <Select
        {...field}
        options={[
          { value: "Recruiter", label: "Recruiter" },
          { value: "Bench Sales", label: "Bench Sales" }
        ]}
        isMulti
        placeholder="Select Designation Type"
        
        // ✅ Display selected values properly
        value={
          field.value
            ? field.value.map((val) => ({
                value: val,
                label: val
              }))
            : []
        }

        // ✅ Store only array of string values in form state
        onChange={(selectedOptions) => {
          const values = selectedOptions ? selectedOptions.map((opt) => opt.value) : [];
          field.onChange(values);
        }}

        styles={{
          control: (provided) => ({
            ...provided,
            minHeight: 50,
            borderRadius: 15,
            borderColor: errors.Usertype ? "red" : provided.borderColor,
          }),
          placeholder: (provided) => ({
            ...provided,
            fontSize: "12px",
            color: "#999",
          }),
          menu: (provided) => ({
            ...provided,
            fontSize: "12px",
          }),
          option: (provided) => ({
            ...provided,
            fontSize: "12px",
          }),
        }}
        className={`basic-form ${errors.Usertype ? "is-invalid" : ""}`}
      />
    )}
  />

  {errors.Usertype && (
    <div className="invalid-feedback d-block">
      {errors.Usertype.message}
    </div>
  )}
</div>

</div>


                   <div className='text-center'>
                  <button disabled={isSubmitting} class="btn btn-primary " style={{backgroundColor:"#00a7ac",border:"none",borderRadius: 15}}>
                  {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
               Submit
                </button> 
               <Link to="/Employer/ListofUsers"> <button  class="btn btn-primary " style={{backgroundColor:"#00a7ac",border:"none",borderRadius: 15}}>
    
                 Cancel
                </button>
                </Link>

                </div> 
        </div>
        </div>
        </form>
   </div>
  </div>
}

    </ConsultantLayout>
    </>
  )
}

export default AddUser;